import { render, staticRenderFns } from "./Navegador.vue?vue&type=template&id=c24aa20e&scoped=true"
import script from "./Navegador.vue?vue&type=script&lang=js"
export * from "./Navegador.vue?vue&type=script&lang=js"
import style0 from "./Navegador.vue?vue&type=style&index=0&id=c24aa20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24aa20e",
  null
  
)

export default component.exports